import React, { useState, useEffect } from 'react';

import FormInputText from '../../../components/common/stories/FormInputText';
import FormButton from '../../../components/common/stories/FormButton';

const SEOSettings = ({ website, onUpdate, isSaving }) => {
  const [title, setTitle] = useState(website?.seo?.title || '');
  const [description, setDescription] = useState(website?.seo?.description || '');
  const [ogImageUrl, setOgImageUrl] = useState(website?.seo?.og_image_url || '');

  useEffect(() => {
    setTitle(website?.seo?.title || '');
    setDescription(website?.seo?.description || '');
    setOgImageUrl(website?.seo?.og_image_url || '');
  }, [website]);

  const handleSave = async () => {
    await onUpdate({
      seo: {
        title,
        description,
        og_image_url: ogImageUrl,
      },
    });
  };

  // Truncate for preview
  const previewTitle = title.length > 60 ? title.substring(0, 57) + '...' : title;
  const previewDescription = description.length > 160 ? description.substring(0, 157) + '...' : description;
  const previewUrl = website?.custom_domain_verified
    ? `https://${website.custom_domain}`
    : `https://${website?.slug || `${website?.subdomain_slug}-${website?.org_slug}`}.${process.env.REACT_APP_PLATFORM_DOMAIN || 'adgro.app'}`;

  return (
    <div className="settings-form">
      <div className="form-section">
        <h4 className="form-section-title">SEO Settings</h4>
        <p className="helper-text">
          Optimize how your website appears in search engine results.
        </p>

        <div className="form-row">
          <FormInputText
            label=""
            placeholder="Page Title (e.g., Joe's Grocery - Fresh Food Weekly)"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            width="90%"
          />
        </div>
        <p className="helper-text" style={{ marginTop: -10 }}>
          {title.length}/60 characters (recommended max)
        </p>

        <div className="form-row" style={{ marginTop: 15 }}>
          <textarea
            placeholder="Meta Description - Describe your store in 1-2 sentences for search results"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            style={{
              width: '90%',
              minHeight: 100,
              padding: '10px 15px',
              border: '1px solid #ddd',
              borderRadius: 6,
              fontSize: 14,
              fontFamily: 'inherit',
              resize: 'vertical',
            }}
          />
        </div>
        <p className="helper-text">
          {description.length}/160 characters (recommended max)
        </p>

        <div className="form-row" style={{ marginTop: 15 }}>
          <FormInputText
            label=""
            placeholder="Social Share Image URL (optional)"
            value={ogImageUrl}
            onChange={(e) => setOgImageUrl(e.target.value)}
            width="90%"
          />
        </div>
        <p className="helper-text" style={{ marginTop: -10 }}>
          Image shown when your site is shared on social media. Use your logo or a promotional image.
        </p>
      </div>

      {/* Google Preview */}
      <div className="seo-preview">
        <h5>Search Engine Preview</h5>
        <div className="seo-preview-title">{previewTitle || 'Your Store Name'}</div>
        <div className="seo-preview-url">{previewUrl}</div>
        <div className="seo-preview-description">
          {previewDescription || 'Your store description will appear here. Write a compelling description to attract customers from search results.'}
        </div>
      </div>

      {/* Save Button */}
      <div style={{ marginTop: 30 }}>
        <FormButton onClick={handleSave} disabled={isSaving}>
          {isSaving ? 'Saving...' : 'Save SEO Settings'}
        </FormButton>
      </div>
    </div>
  );
};

export default SEOSettings;
